var BlockView = require('views/block/base-block-view');
var EnrollmentDataService = require('services/enrollment-data-service');

// TODO: figure out when this block is actually 'complete'
// TODO: review the structure of 'data' and 'columns' to confirm things are in the right spots

var ResultsView = BlockView.extend({
  className: 'results',
  initialize: function(options) {
    BlockView.prototype.initialize.apply(this, arguments);
    this.subscribeEvent('enrollment-data-saved:' + this.model.get('key'), this.setResults, this);
    this.model.set('results', EnrollmentDataService.getData(this.model.get('key')));
  },
  setResults: function(results) {
    this.model.set('results', results);
    this.reRender();
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = ResultsView;